module.exports = __webpack_public_path__ + "static/img/big_btn1.50e5519f.png";